
import DataReferensi from "@/services/DataReferensi";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";


@Module({ store, dynamic: true, name: "storeReferensi" })
class ReferensiStore extends VuexModule {
  dokter = [];
  unit = [];
  unitAll = [];
  kelas = [];
  status = [];
  bedKosong = [];
  tempStatus ={}

  @Mutation SET_DOKTER(dokter: []) {
    this.dokter = dokter;
  }
  @Mutation SET_UNIT(unit: []) {
    this.unit = unit;
  }
  @Mutation SET_UNIT_All(unitAll: []) {
    this.unitAll = unitAll;
  }
  @Mutation SET_KELAS(kelas: []) {
    this.kelas = kelas;
  }
  @Mutation SET_STATUS(status: []) {
    this.status = status;
  }
  @Mutation SET_BED_KOSONG(bedKosong: []) {
    this.bedKosong = bedKosong;
  }
  @Mutation SET_TEMP_STATUS(tempStatus) {
    this.tempStatus = tempStatus;
  }

  @Action actDokter() {
    const dt = DataReferensi.getDataDokter()
    dt.then(dt => {
      const dokter = dt.data;
      this.SET_DOKTER(dokter);
    });
  }
  @Action actUnit() {
    const dt = DataReferensi.getDataUnit()
    dt.then(dt => {
      const unit = dt.data;
      this.SET_UNIT(unit);
    });
  }
  @Action actUnitAll() {
    const dt = DataReferensi.getDataUnitAll()
    dt.then(dt => {
      const unitAll = dt.data;
      this.SET_UNIT_All(unitAll);
    });
  }
  @Action actKelas() {
    const dt = DataReferensi.getDataKelas()
    dt.then(dt => {
      const kelas = dt.data;
      this.SET_KELAS(kelas);
    });
  }
  @Action actStatus() {
    const dt = DataReferensi.getDataStatus()
    dt.then(dt => {
      const status = dt.data;
      this.SET_STATUS(status);
    });
  }
  @Action actBedKosongByUnit(unitID) {
    const dt = DataReferensi.getDataBedKosongByUnit(unitID)
    dt.then(dt => {
      const bedKosong = dt.data;
      this.SET_BED_KOSONG(bedKosong);
    });
  }
  @Action actTempStatus(val) {
    this.SET_TEMP_STATUS(val)
  }
}

export const storeReferensi= getModule(ReferensiStore);
